 export enum EnumQuoteServiceSalesType {
     NEW = 'NEW',
     EXISTING = 'EXISTING',
     RENEWAL = 'RENEWAL'
}

